import { initializeApp } from 'firebase/app';
import { getMessaging, getToken } from 'firebase/messaging';

// Firebase config (replace with your own)
const firebaseConfig = {
  apiKey: "AIzaSyAqXr0O7tE-qR2hOcHr0UPbziy5NIa4evA",
  authDomain: "hrms-test-d0982.firebaseapp.com",
  projectId: "hrms-test-d0982",
  storageBucket: "hrms-test-d0982.firebasestorage.app",
  messagingSenderId: "230687736243",
  appId: "1:230687736243:web:fc546d0f341f3af935cbc6",
  measurementId: "G-2PB8BP7VRZ"
};


const vapidKey = "BPzOd7a_4t9cjJm7vTA023xb75nE3953MGe1yaiZOtsLm9GDKtfHYRJZGl_Pudq6GMQ7NMSdjtEVsvonOLST-pM"


// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Get messaging instance
const messaging = getMessaging(app);



export { messaging, getToken };

// export const requestFCMToken = async () => {
//   return Notification.requestPermission()
//     .then((permission) => {
//       if (permission === "granted") {
//         return getToken(messaging, { vapidKey })
//       } else {
//         throw new Error("Noficiation not granted")
//       }
//     })
//     .catch((err) => {
//       console.error("Error getting FCM token: ", err)
//       throw err;
//     })
// }

// export const requestFCMToken = async () => {
//   return Notification.requestPermission()
//     .then((permission) => {
//       if (permission === "granted") {
//         return getToken(messaging, { vapidKey })
//       } else {
//         throw new Error("Noficiation not granted")
//       }
//     })
//     .catch((err) => {
//       console.error("Error getting FCM token: ", err)
//       throw err;
//     })
// }

export const requestFCMToken = async () => {
  try {
    // Attempt to get the FCM token
    const token = await getToken(messaging, { vapidKey });

    if (token) {
      console.log("FCM Token:", token);
      return token;
    } else {
      console.warn("No FCM token available.");
      return null; // Return null instead of throwing an error
    }
  } catch (error) {
    console.error("Error getting FCM token:", error);
    return null; // Ensure it returns null on failure instead of getting stuck
  }
};
